import { render, staticRenderFns } from "./SecurityQuestionModal.vue?vue&type=template&id=197e2557&scoped=true"
import script from "./SecurityQuestionModal.vue?vue&type=script&lang=js"
export * from "./SecurityQuestionModal.vue?vue&type=script&lang=js"
import style0 from "./SecurityQuestionModal.vue?vue&type=style&index=0&id=197e2557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e2557",
  null
  
)

export default component.exports